import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "react-bootstrap-v5";
import './buttons.scss'

const ButtonIcon = ({className, onClick, selected, icon}) => (
    <Button className={`button-${className} ${selected}`} onClick={onClick}><FontAwesomeIcon icon={icon}/></Button>
);

export default ButtonIcon;